import { Modal, Button } from 'react-bootstrap';

function CustomModal(props) {
    const defaultProps = {
        showButtons: true,
        showHeader: true,
        size: ''
    }
    props = {...defaultProps,...props};
    return (
        <>
            <Modal show={props.show} onHide={props.handleClose} size={props.size}>
                {props.showHeader && (
                    <div className="modal-header">
                        <h4 className="modal-title">{props.title}</h4>
                        <button onClick={props.handleClose} type="button" className="bnt-close close" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                )}
                <Modal.Body>{props.content}</Modal.Body>
                {props.showButtons && (
                    <Modal.Footer>
                        <Button variant="secondary" onClick={props.handleCancel}>
                            Não
                        </Button>
                        <Button variant="primary" onClick={props.handleConfirm}>
                            Sim
                        </Button>
                    </Modal.Footer>
                )}
            </Modal>
        </>
    );
}

export default CustomModal;
